import { Navigate } from 'react-router-dom'

import { EClientPath } from '~/models/api'

function HomePage() {
  return <Navigate to={EClientPath.login} replace />
}

export default HomePage
